import { ReactElement } from 'react';
import { ActionData, Group } from '../constants/telosair-interfaces';
import GroupRow from './GroupRow';

type GroupsTableComponentProps = {
  groups: Group[];
  handleAction: (data: ActionData<Group>) => void;
  setIsGroupModalOpen: (isOpen: boolean) => void;
};

/**
 * A Groups Table Component.
 * @param props - Groups Table Component Props.
 * @returns - A React Component.
 */
export default function GroupsTable(props: GroupsTableComponentProps): ReactElement {
  const { groups, handleAction, setIsGroupModalOpen } = props;

  const sensors = groups.reduce((acc: number, curr) => {
    const { sensorDetailsList } = curr;
    return acc + sensorDetailsList.length;
  }, 0);

  const sortedGroups: Group[] = [...groups].sort(
    (a: Group, b: Group) =>
      new Date(b.lastModifiedDate).getTime() - new Date(a.lastModifiedDate).getTime()
  );

  return (
    <div className="rounded shadow-md bg-white dark:bg-container-700 flex text-gray-400 dark:text-gray-400 text-sm font-medium border-b border-b-gray-300 dark:border-b-gray-900">
      <table className="w-full">
        <thead>
          <tr className="w-full text-gray-400 text-xs font-medium">
            <th className="px-6 py-3 text-left flex items-center">
              Group Name ({groups.length} Groups | {sensors} Devices)
            </th>
            <th className="text-center hidden lg:table-cell" aria-hidden="true" />
            <th className="text-center hidden lg:table-cell" aria-hidden="true" />
            <th className="text-center">No. of devices</th>
            <th className="text-center">Last Modified</th>
            <th className="text-center">Action</th>
          </tr>
        </thead>
        <tbody>
          {sortedGroups.map((group) => (
            <GroupRow
              setIsGroupModalOpen={setIsGroupModalOpen}
              handleAction={handleAction}
              key={group.groupId}
              group={group}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}
